const replaceVariables = (msg = '', variables = [], data = {}) => {
  let output = msg;
  if (!variables.length || !Object.keys(data).length) { return output; }
  variables.forEach((v) => {
    output = output.replaceAll(`{{${v}}}`, data[v]?.trim());
    // data[v]?.trim() can be undefined if CSV rows doesnt have this field..
    // leaving to show undefined in preview and hopefully sender sees
    // and adjusts the CSV or the template.
  });

  return output;
};

export default replaceVariables;
